'use client'
import { useTranslations, useLocale } from 'next-intl'
import { useIsLoggedInQuery } from 'auth/hooks'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { Button } from '@repo/design-system-cf/components/button'
import { Link } from '@repo/web-ui/components/link'
import { addOrReplaceLocaleInUrl } from 'cf-i18n/helpers'

export function MyDowmoalds() {
  const isLoggedInQuery = useIsLoggedInQuery()
  const t = useTranslations('social-feed.page.crafter_profile')
  const locale = useLocale()

  if (!isLoggedInQuery.data) {
    return null
  }

  return (
    <div className="p-4 border border-[#1313151F] bg-cf-white rounded-[12px] w-64 shrink-0 mb-4">
      <p className="text-16 font-semibold text-cf-black mb-2">{t('post_project')}</p>
      <p className="mb-3 text-cf-grey-800">{t('right_side_text')}</p>
      <div className="flex flex-col gap-3 mb-4">
        <div className="flex gap-2 text-12">
          <div className="text-cf-grey-800 bg-cf-grey-100 rounded-full w-5 h-5 inline-flex items-center justify-center font-bold tabular-nums leading-none shrink-0">
            1.
          </div>
          <div className="text-cf-grey-800 font-medium">{t('download_step_1')}</div>
        </div>
        <div className="flex gap-2 text-12">
          <div className="text-cf-grey-800 bg-cf-grey-100 rounded-full w-5 h-5 inline-flex items-center justify-center font-bold tabular-nums leading-none shrink-0">
            2.
          </div>
          <div className="text-cf-grey-800 font-medium">{t('download_step_2')}</div>
        </div>
        <div className="flex gap-2 text-12">
          <div className="text-cf-grey-800 bg-cf-grey-100 rounded-full w-5 h-5 inline-flex items-center justify-center font-bold tabular-nums leading-none shrink-0">
            3.
          </div>
          <div className="text-cf-grey-800 font-medium">{t('download_step_3')}</div>
        </div>
      </div>
      <Button className="w-full flex justify-center items-center" asChild={true}>
        <Link
          href={addOrReplaceLocaleInUrl(AppRoutes.LICENSE_KEYS_OVERVIEW, locale)}
          target="_blank"
        >
          {t('go_my_downloads')}
        </Link>
      </Button>
    </div>
  )
}
